"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isURI = void 0;
exports.isURI = (value) => new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?").test(value);
//# sourceMappingURL=is-uri.js.map